export const SUBMISSION_FORMS = 'SUBMISSION_FORMS';
export const SEND = 'SEND';